function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.522 0c3.604 0 6.521 3.034 6.521 6.77 0 1.505-.836 3.626-1.908 5.73C12.21 16.278 9.522 20 9.522 20S6.8 16.297 4.873 12.5C3.818 10.421 3 8.314 3 6.77 3 3.126 5.918 0 9.522 0zm0 5.217a2.174 2.174 0 100 4.349 2.174 2.174 0 000-4.349z",
  fill: "#262626",
  fillRule: "nonzero"
});

function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgPin;